const OPTIONS = [
  { value: "", label: "Të gjitha" },
  { value: "PEF", label: "PEF" },
  { value: "SEF", label: "SEF" },
];

/* Segmented PEF / SEF switch shown next to the receipt search input.
   value: "" (all), "PEF" or "SEF" — sent to the backend as the `type` param. */
export default function ReceiptTypeFilter({ value = "", onChange }) {
  return (
    <div
      role="radiogroup"
      aria-label="Lloji i kuponit"
      className="h-11 inline-flex shrink-0 items-center gap-1 rounded-xl border border-gray-200 bg-white p-1 shadow-sm"
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value || "all"}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange?.(opt.value)}
            className={`h-full flex-1 sm:flex-none rounded-lg px-3.5 text-sm font-semibold whitespace-nowrap transition ${
              active
                ? "bg-[var(--secondary-color)] text-white shadow-sm"
                : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
